module.exports = require("d3-shape");


/*****************
 ** WEBPACK FOOTER
 ** external "d3-shape"
 ** module id = 154
 ** module chunks = 0 1
 **/